import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { Grid } from '@material-ui/core';
import compStyles from './home.module.scss'

const Pictures = (props) => {
  const images = useStaticQuery(graphql`
    query {
      placeholderImage: allFile(filter: {extension: {regex: "/(jpg)|(jpeg)|(png)/"}, relativeDirectory: {eq: "pictures"}}) {
        edges{
          node{
            base
              childImageSharp {
                fluid(quality: 100, maxWidth: 400, maxHeight: 260) {
                  ...GatsbyImageSharpFluid
                }
              }
          }
        }
      }
    }
  `)
  return (
    <Grid container direction="row"  justify="space-around" alignItems="center">
       {
        images.placeholderImage.edges.map( (banner, index) => {
          return (<Grid item  md={4}  key={index} className={compStyles.gallery__item}>
            <Img classes={compStyles.pictures__image} fluid={banner.node.childImageSharp.fluid} />
          </Grid>)
        })
      }
      
    </Grid>
  )
}

export default Pictures;